<script>
    import { fly } from "svelte/transition";
    import { ProgressCircle } from "../index";
</script>

<div class="example" transition:fly={{ x: 200 }}>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <ProgressCircle percent={80} />
        <ProgressCircle percent={50}>50%</ProgressCircle>
    </div>

    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <ProgressCircle percent={75} line="2" />
        <ProgressCircle percent={75} line="4" />
        <ProgressCircle percent={75} line="6" />
    </div>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <ProgressCircle percent={50} size="20">
            <span>50%</span>
        </ProgressCircle>
        <ProgressCircle percent={75} size="30">
            <span>75%</span>
        </ProgressCircle>
        <ProgressCircle percent={100} size="40">
            <span>100%</span>
        </ProgressCircle>
    </div>
    <h4 class="example-title">基础用法</h4>
    <div class="example-body">
        <ProgressCircle percent={60} --fill-color="var(--sui-color-success)">
            60%
        </ProgressCircle>
        <ProgressCircle percent={60} --fill-color="var(--sui-color-warning)">
            60%
        </ProgressCircle>
        <ProgressCircle percent={60} --fill-color="var(--sui-color-danger)">
            60%
        </ProgressCircle>
    </div>
</div>

<style lang="less">
    @import "./example.less";
</style>
